import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AiModule } from '../features/ai/ai.module';
import { SharedCommonModule } from '../shared/shared-common.module';

// Singleton Components - App-level, loaded once
import { ApplicationLoadingComponent } from '../components/app-application-loading/app-application-loading.component';
import { NotFoundPageComponent } from '../components/not-found-page/not-found-page.component';
import { UnauthorizedComponent } from '../components/unauthorized/unauthorized.component';

/**
 * CoreModule
 *
 * Purpose: Contains singleton components that should be loaded once at the application level.
 *
 * IMPORTANT: This module should ONLY be imported in AppModule.
 * Attempting to import it elsewhere will throw an error.
 *
 * Components:
 * - ApplicationLoadingComponent: App-wide loading indicator
 * - NotFoundPageComponent: 404 page
 * - UnauthorizedComponent: 401/403 page
 */
@NgModule({
  declarations: [
    ApplicationLoadingComponent,
    NotFoundPageComponent,
    UnauthorizedComponent,
  ],
  imports: [CommonModule, NgbModule, AiModule, SharedCommonModule],
  exports: [
    ApplicationLoadingComponent,
    NotFoundPageComponent,
    UnauthorizedComponent,
  ],
})
export class CoreModule {}
